import { render } from "./XIconSolidUsersThree.vue?vue&type=template&id=ec81af32"
import script from "./XIconSolidUsersThree.vue?vue&type=script&lang=js"
export * from "./XIconSolidUsersThree.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidUsersThree.vue"]])

export default __exports__